/* Mídia: metadados e URL assinada de um anexo já enviado. */
import { z } from "zod";
import { request } from "./core";

export const mediaApi = {
  /**
   * O schema aqui é `z.object`, que DESCARTA campo desconhecido em silêncio —
   * foi assim que `durationMs` sumiu uma vez. A duração que a UI usa vem do DTO
   * canônico da mensagem (`mediaDurationMs`, em `@zapir/shared`); se um dia esta
   * rota tiver que devolver `durationMs`, o campo precisa entrar no schema
   * abaixo, senão o zod o joga fora antes da tela ver.
   */
  async media(id: string): Promise<{ id: string; status: string; mimeType: string | null; fileName: string | null; url: string | null }> {
    return request(`/media/${id}`, {
      schema: z.object({
        id: z.string(),
        status: z.string(),
        mimeType: z.string().nullable(),
        fileName: z.string().nullable(),
        url: z.string().nullable(),
      }),
    });
  },
};
